(function() {
  var isMobile = !(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var pendingVideos = [];

  function unlockPending() {
    while (pendingVideos.length) {
      var v = pendingVideos.shift();
      if (v.isConnected && v.paused) {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }
  }

  function armUnlock() {
    ['touchstart', 'click', 'scroll'].forEach(function (evt) {
      document.addEventListener(evt, unlockPending, { once: true, passive: true });
    });
  }
  armUnlock();

  function pauseAll(root) {
    var vids = root.querySelectorAll('video[data-plp-video]');
    Array.prototype.forEach.call(vids, function (v) {
      if (!v.paused) v.pause();
    });
  }

  /* ---------- video memory release ----------
     Pausing merely stops playback - iOS Safari keeps the decoder/buffer memory for a
     <video> allocated until its source is actually cleared and load() is called. With
     several video-bearing cards per grid this adds up fast once the user has scrolled
     or swiped through a few of them, so cards far off-screen get fully released, and
     the source is restored on demand the next time that card's video needs to play. */

  function ensureVideoSource(video) {
    var source = video.querySelector('source');
    if (source && !source.getAttribute('src') && source.dataset.src) {
      source.setAttribute('src', source.dataset.src);
      video.load();
    }
  }

  function releaseVideo(video) {
    if (video.dataset.loaded !== '1') return;

    var source = video.querySelector('source');
    if (source) {
      var src = source.getAttribute('src');
      if (src) {
        source.dataset.src = src;
        source.removeAttribute('src');
      }
    }

    try {
      video.pause();
      video.removeAttribute('src');
      video.load();
    } catch (e) {}

    video.dataset.loaded = '';
  }

  function releaseContainerVideos(container) {
    var vids = container.querySelectorAll('video[data-plp-video]');
    Array.prototype.forEach.call(vids, releaseVideo);
  }

  /* Swiper lays every slide out in the DOM side by side (clipped visually via overflow:hidden
     on the parent, not display:none), so a plain native loading="lazy" on slide 2+ doesn't
     actually defer anything - the image sits geometrically adjacent to the visible slide, well
     within the browser's lazy-load distance threshold, and loads immediately regardless. The
     Liquid template renders these with data-src/data-srcset instead of src/srcset for exactly
     this reason; promote them to the real attributes once the card has actually dwelled in view. */
  function promoteSlideImage(img) {
    var src = img.getAttribute('data-src');
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }

    var srcset = img.getAttribute('data-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
  }

  function ensureSlideImages(container) {
    var imgs = container.querySelectorAll('.swiper-slide img[data-src], .swiper-slide img[data-srcset]');
    Array.prototype.forEach.call(imgs, promoteSlideImage);
  }

  // SP-1685: slide a card should show - packshot in packshot view, else the selected colour's first image.
  function targetSlideIndex(slider) {
    return isPackshotMode() ? getPackshotIndex(slider) : Number(slider.dataset.siblingSlideIndex || 0);
  }

  function promoteTargetSlide(slider, index) {
    var slides = slider.querySelectorAll('.swiper-slide');
    var image = slides[index] && slides[index].querySelector('img');
    if (image) promoteSlideImage(image);
  }

  // Without a live Swiper (not created yet / destroyed off-screen) the track would sit on slide 0.
  function presetSlide(slider, index) {
    var wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper || (slider.swiper && !slider.swiper.destroyed)) return;
    wrapper.style.transform = index > 0 ? 'translate3d(' + (-index * 100) + '%, 0, 0)' : '';
  }

  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > -100 && r.top < vh + 100;
  }

  function resumeVisibleVideos() {
    if (prefersReducedMotion) return;

    var containers = document.querySelectorAll('[data-plp-swipe]');
    Array.prototype.forEach.call(containers, function (c) {
      var slider = c.querySelector('[data-plp-swipe-slider]');
      if (!slider || !slider.swiper) return;

      if (!isInViewport(c)) {
        c.dataset.offscreen = '1';
        return;
      }
      c.dataset.offscreen = '0';
      ensureSlideImages(c);
      playActiveVideo(slider.swiper);
    });
  }

  function playActiveVideo(swiper) {
    if (prefersReducedMotion) return;

    var root = swiper.el.closest('[data-plp-swipe]') || swiper.el;
    pauseAll(root);

    if (root.dataset.offscreen === '1') return;

    var active = swiper.slides[swiper.activeIndex];
    if (!active) return;

    var vid = active.querySelector('video[data-plp-video]');
    if (!vid) return;
    vid.muted = true;
    vid.defaultMuted = true;
    vid.playsInline = true;

    ensureVideoSource(vid);
    if (vid.networkState === 0 && !vid.dataset.loaded) {
      vid.load();
    }
    vid.dataset.loaded = '1';

    var p = vid.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        if (pendingVideos.indexOf(vid) === -1) pendingVideos.push(vid);
        armUnlock();
      });
    }
  }

  /* ---------- Swiper instance lifecycle ----------
     Beyond the video, the Swiper instance itself (touch listeners, internal slide state) has a
     real cost, and a grid can hold well over fifty swipe-eligible cards at once. Rather than
     constructing every card's Swiper eagerly at load and letting it live forever, instances are
     created lazily as a card approaches the viewport and fully destroyed once it's scrolled far
     away - not just video-emptied. A card whose Swiper was destroyed is recreated the same way
     the next time it comes back near. */

  function createSwiperFor(container) {
    var el = container.querySelector('[data-plp-swipe-slider]');
    if (!el || el.swiper || typeof Swiper === 'undefined') return;

    var startIndex = targetSlideIndex(el);

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: startIndex, // SP-1685: no slide 0 -> packshot jump
      loop: false,
      threshold: 10,
      touchAngle: 30,
      resistance: true,
      resistanceRatio: 0.85,
      watchOverflow: true,
      on: {
        slideChangeTransitionEnd: function () {
          playActiveVideo(this);
        },
        touchStart: function () {
          container.style.zIndex = '2';
        },
        touchEnd: function () {
          container.style.zIndex = '';
        }
      }
    });

    if (isPackshotMode()) applyPackshotState(container, true);

    /* Also promote images right when the Swiper is created, not just via visibilityObserver:
       a card already on-screen at page load gets both observers' callback before this Swiper
       exists, so visibilityObserver's promotion check misses it and never fires again. */
    if (container.dataset.offscreen !== '1') {
      ensureSlideImages(container);
    } else {
      promoteTargetSlide(el, startIndex);
    }
  }

  function destroySwiperFor(container) {
    cancelPendingPlay(container);
    releaseContainerVideos(container);

    var el = container.querySelector('[data-plp-swipe-slider]');
    if (!el || !el.swiper) return;

    try {
      el.swiper.destroy(true, true);
    } catch (e) {}

    // SP-1685: Swiper 9.1 a11y never removes its live-region <span> on destroy.
    Array.prototype.forEach.call(el.querySelectorAll('.swiper-notification'), function (node) {
      if (node.parentNode === el) node.remove();
    });

    presetSlide(el, targetSlideIndex(el));
  }

  /* One shared observer per concern for the whole grid, instead of one IntersectionObserver
     instance per product card - with infinite scroll a grid can hold hundreds of cards, and
     WebKit's IntersectionObserver is materially more expensive per-instance than Chromium's. */

  var createObserver = null;
  var visibilityObserver = null;
  var destroyObserver = null;
  var CREATE_MARGIN = '300px 0px';
  var DESTROY_MARGIN = '1000px 0px';

  /* A fast scroll can carry a card across a margin and back out past another within the same
     gesture - each transition individually correct, but together a burst of real "create/load,
     then destroy/strip/reload" cycles across many cards in a couple of seconds. Debouncing the
     create and play triggers so a card only actually acts on them after it's stayed in view for
     a moment means a card the user merely scrolls past never starts either at all. Destroy has
     no such debounce - tearing down something already fully off-screen is always safe and cheap,
     the risk is only in doing expensive work for a card that's just passing through. */
  var CREATE_DWELL_MS = 200;
  var pendingCreate = new WeakMap();
  var PLAY_DWELL_MS = 200;
  var pendingPlay = new WeakMap();

  /* A fast scroll can carry many cards past the 300px creation margin at once, so their 200ms
     dwells can all finish together and burst-create (and burst-decode images for) several
     Swipers in the same tick. Trickle them through a small queue instead. */
  var createQueue = [];
  var createQueueRunning = false;
  var CREATE_QUEUE_STAGGER_MS = 75;

  function processCreateQueue() {
    if (!createQueue.length) {
      createQueueRunning = false;
      return;
    }
    createQueueRunning = true;
    var container = createQueue.shift();
    createSwiperFor(container);
    setTimeout(processCreateQueue, CREATE_QUEUE_STAGGER_MS);
  }

  function enqueueCreate(container) {
    if (createQueue.indexOf(container) !== -1) return;
    createQueue.push(container);
    if (!createQueueRunning) processCreateQueue();
  }

  function dequeueCreate(container) {
    var idx = createQueue.indexOf(container);
    if (idx !== -1) createQueue.splice(idx, 1);
  }

  function scheduleCreate(container) {
    cancelPendingCreate(container);

    var timeoutId = setTimeout(function () {
      pendingCreate.delete(container);
      enqueueCreate(container);
    }, CREATE_DWELL_MS);

    pendingCreate.set(container, timeoutId);
  }

  function cancelPendingCreate(container) {
    var timeoutId = pendingCreate.get(container);
    if (timeoutId) {
      clearTimeout(timeoutId);
      pendingCreate.delete(container);
    }
    dequeueCreate(container);
  }

  function schedulePlay(container, swiper) {
    cancelPendingPlay(container);

    var timeoutId = setTimeout(function () {
      pendingPlay.delete(container);
      if (container.dataset.offscreen !== '1') {
        ensureSlideImages(container);
        playActiveVideo(swiper);
      }
    }, PLAY_DWELL_MS);

    pendingPlay.set(container, timeoutId);
  }

  function cancelPendingPlay(container) {
    var timeoutId = pendingPlay.get(container);
    if (timeoutId) {
      clearTimeout(timeoutId);
      pendingPlay.delete(container);
    }
  }

  function getCreateObserver() {
    if (createObserver || !('IntersectionObserver' in window)) return createObserver;

    createObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            scheduleCreate(entry.target);
          } else {
            cancelPendingCreate(entry.target);
          }
        });
      },
      { rootMargin: CREATE_MARGIN, threshold: 0 }
    );

    return createObserver;
  }

  function getVisibilityObserver() {
    if (visibilityObserver || !('IntersectionObserver' in window)) return visibilityObserver;

    visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          var slider = el.querySelector('[data-plp-swipe-slider]');

          if (entry.isIntersecting) {
            el.dataset.offscreen = '0';
            if (slider && slider.swiper) schedulePlay(el, slider.swiper);
          } else {
            el.dataset.offscreen = '1';
            cancelPendingPlay(el);
            pauseAll(el);
          }
        });
      },
      { rootMargin: '100px 0px', threshold: 0.25 }
    );

    return visibilityObserver;
  }

  function getDestroyObserver() {
    if (destroyObserver || !('IntersectionObserver' in window)) return destroyObserver;

    destroyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) destroySwiperFor(entry.target);
        });
      },
      { rootMargin: DESTROY_MARGIN, threshold: 0 }
    );

    return destroyObserver;
  }

  function observeContainer(container) {
    if (container.dataset.observed === '1') return;
    container.dataset.observed = '1';

    if (isPackshotMode()) {
      var slider = container.querySelector('[data-plp-swipe-slider]');
      if (slider) presetSlide(slider, targetSlideIndex(slider));
    }

    var cio = getCreateObserver();
    if (cio) cio.observe(container);

    var vio = getVisibilityObserver();
    if (vio) vio.observe(container);

    var dio = getDestroyObserver();
    if (dio) dio.observe(container);
  }

  /* The shared observers above are page-lifetime objects that never go away, so unlike the old
     one-observer-per-card design, a container they've observed is held alive by them forever
     unless explicitly unobserved. Filters/sort do a full innerHTML replace of the grid wrapper
     (see below), which orphans every card from the previous result set on every single filter
     interaction - without this, that whole subtree (Swiper instance, video buffers, listeners)
     would leak permanently, compounding with every filter/sort/pagination action. */

  function cleanupSwipeContainer(container) {
    if (createObserver) createObserver.unobserve(container);
    if (visibilityObserver) visibilityObserver.unobserve(container);
    if (destroyObserver) destroyObserver.unobserve(container);
    cancelPendingCreate(container);
    cancelPendingPlay(container);
    releaseContainerVideos(container);

    var slider = container.querySelector('[data-plp-swipe-slider]');
    if (slider && slider.swiper) {
      try {
        slider.swiper.destroy(true, true);
      } catch (e) {}
    }
  }

  function cleanupRemovedNode(node) {
    if (node.nodeType !== 1) return;
    if (node.hasAttribute('data-plp-swipe')) cleanupSwipeContainer(node);
    if (node.querySelectorAll) {
      Array.prototype.forEach.call(node.querySelectorAll('[data-plp-swipe]'), cleanupSwipeContainer);
    }
  }


  function removeDuplicateDesktopVideos() {
    // The desktop card is display:none on mobile but its <video> still downloads
    // and can steal playback. Strip it.
    var stale = document.querySelectorAll('.plp-desktop-only .product-item__video');
    Array.prototype.forEach.call(stale, function (el) {
      var vids = el.querySelectorAll('video');
      Array.prototype.forEach.call(vids, function (v) {
        try {
          v.pause();
          v.removeAttribute('src');
          v.load();
        } catch (e) {}
      });
      el.remove();
    });
  }

  function initPlpSwipe() {
    if (!isMobile) return;

    removeDuplicateDesktopVideos();

    var containers = document.querySelectorAll('[data-plp-swipe]:not([data-observed])');
    if (!containers.length || typeof Swiper === 'undefined') return;

    Array.prototype.forEach.call(containers, observeContainer);
  }

  function getSlides(slider) {
    var swiper = slider.swiper;
    return swiper && !swiper.destroyed ? swiper.slides : slider.querySelectorAll('.swiper-slide');
  }

  function slideIndex(slide, index) {
    var originalIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    return isNaN(originalIndex) ? index : originalIndex;
  }

  // Slide images render as data-src/data-srcset until the lazy hydrator promotes them.
  function imageSource(image) {
    return image.getAttribute('src') || image.getAttribute('data-src') || '';
  }

  function isPackshotMode() {
    var toggle = document.getElementById('inverse-packshots');
    return toggle ? toggle.checked : localStorage.getItem('plp-packshot') === 'true';
  }

  function getPackshotIndex(slider) {
    var container = slider.closest('[data-plp-swipe]');
    var cachedIndex = slider.dataset.packshotSlideIndex;
    var packshotIndex = parseInt(cachedIndex || container.getAttribute('data-packshot-index') || '0', 10);
    var slides = Array.prototype.slice.call(getSlides(slider));
    var imageSlides = slides.filter(function (slide) {
      return slide.querySelector('img') && !slide.querySelector('video');
    });
    var packshotSlide = imageSlides.find(function (slide) {
      return slideIndex(slide, slides.indexOf(slide)) === packshotIndex;
    });
    if (!packshotSlide || (cachedIndex === undefined && !/_packshot/i.test(imageSource(packshotSlide.querySelector('img'))))) {
      packshotSlide = imageSlides.find(function (slide) {
        return /_packshot/i.test(imageSource(slide.querySelector('img')));
      }) || packshotSlide || imageSlides[0];
    }
    if (!packshotSlide) return 0;
    packshotIndex = slideIndex(packshotSlide, slides.indexOf(packshotSlide));
    slider.dataset.packshotSlideIndex = packshotIndex;
    container.setAttribute('data-packshot-index', packshotIndex);
    return packshotIndex;
  }

  function slideSources(image, source) {
    var imageUrl = new URL(source, window.location.href);
    var srcset = (image.getAttribute('srcset') || image.getAttribute('data-srcset') || '').split(',').map(function (candidate) {
      var descriptor = candidate.trim().split(/\s+/).pop();
      if (!/^\d+w$/.test(descriptor)) return '';
      var sourceUrl = new URL(imageUrl.href);
      sourceUrl.searchParams.set('width', parseInt(descriptor, 10));
      return sourceUrl.href + ' ' + descriptor;
    }).filter(Boolean).join(', ');

    var fallbackUrl = new URL(imageUrl.href);
    fallbackUrl.searchParams.set('width', '800');
    return { src: fallbackUrl.href, srcset: srcset, url: imageUrl };
  }

  function findSlideImage(slider, targetIndex) {
    var found = null;
    Array.prototype.some.call(getSlides(slider), function (slide, index) {
      if (slideIndex(slide, index) !== targetIndex) return false;
      found = slide.querySelector('img');
      return !!found;
    });
    return found;
  }

  // SP-1685: decode off-DOM before touching the visible slide - WebKit blanks an <img> as soon as its src changes.
  var PRELOAD_TIMEOUT_MS = 4000;

  function preloadImage(src, srcset, sizes) {
    return new Promise(function (resolve) {
      var done = false;
      var timer = null;
      var image = new Image();
      var finish = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        image.onload = image.onerror = null;
        resolve();
      };
      timer = setTimeout(finish, PRELOAD_TIMEOUT_MS);
      if (sizes) image.sizes = sizes;
      if (srcset) image.srcset = srcset;
      if (src) image.src = src;
      if (!src && !srcset) return finish();
      if (typeof image.decode === 'function') {
        image.decode().then(finish, finish);
      } else {
        image.onload = image.onerror = finish;
      }
    });
  }

  function updateSlideImage(slider, targetIndex, source, title) {
    var slides = getSlides(slider);
    Array.prototype.forEach.call(slides, function (slide, index) {
      if (slideIndex(slide, index) !== targetIndex) return;
      var image = slide.querySelector('img');
      if (!image) return;

      var sources = slideSources(image, source);
      var imageUrl = sources.url;
      if (sources.srcset) image.setAttribute('srcset', sources.srcset);
      else image.removeAttribute('srcset');

      image.src = sources.src;
      image.alt = title || '';
      // Leaving these would let ensureSlideImages promote the original colour back over this.
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');

      var imageWrapper = image.closest('.image-wrapper');
      if (imageWrapper) {
        var backfillUrl = new URL(imageUrl.href);
        backfillUrl.searchParams.set('width', '1');
        backfillUrl.searchParams.set('height', '1');
        imageWrapper.style.setProperty('--image-backfill', 'url("' + backfillUrl.href + '")');
      }
    });
  }

  function showSlide(slider, targetIndex) {
    var swiper = slider.swiper;
    if (swiper && !swiper.destroyed) {
      swiper.update();
      if (swiper.params.loop) swiper.slideToLoop(targetIndex, 0);
      else swiper.slideTo(targetIndex, 0);
      playActiveVideo(swiper);
      return;
    }
    // SP-1685: scrollLeft here stacked with Swiper's translate once created.
    presetSlide(slider, targetIndex);
    pauseAll(slider);
  }

  function firstImageSlideIndex(slider) {
    var firstIndex = Infinity;
    Array.prototype.forEach.call(getSlides(slider), function (slide, index) {
      if (slide.querySelector('img') && !slide.querySelector('video')) {
        firstIndex = Math.min(firstIndex, slideIndex(slide, index));
      }
    });
    return firstIndex;
  }

  /* ---------- sibling gallery (SP-1685) ----------
     Swaps in the sibling's full slide set (sections/api-plp-swipe-slides). Only HTML strings are
     cached; inserted images stay lazy like the server-rendered card. */

  var siblingSlidesCache = new Map();
  var siblingSlidesRequests = new Map();
  var SIBLING_SLIDES_CACHE_MAX = 20;

  function renderedSlidesHandle(slider) {
    if (slider.dataset.slidesHandle !== undefined) return slider.dataset.slidesHandle;
    var card = slider.closest('[data-product-handle]');
    return card ? card.getAttribute('data-product-handle') : '';
  }

  // Once true, SP-1676's per-slide overrides must not be applied on top.
  function hasSiblingSlides(slider) {
    return !!slider.dataset.siblingHandle && renderedSlidesHandle(slider) === slider.dataset.siblingHandle;
  }

  function fetchSiblingSlides(handle) {
    if (siblingSlidesRequests.has(handle)) return siblingSlidesRequests.get(handle);

    var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    var request = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=api-plp-swipe-slides')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html;
        var slides = template.content.querySelector('[data-plp-swipe-slides]');
        if (!slides || !slides.querySelector('.swiper-slide')) return null;

        var packshotIndex = slides.getAttribute('data-packshot-index') || '0';
        var slideList = Array.prototype.slice.call(slides.querySelectorAll('.swiper-slide'));
        var imageSource = function (slide) {
          var image = slide && !slide.querySelector('video') && slide.querySelector('img');
          return image ? { src: image.getAttribute('data-src') || '', srcset: image.getAttribute('data-srcset') || '' } : null;
        };
        var data = {
          html: slides.innerHTML,
          packshotIndex: packshotIndex,
          firstImage: slideList.map(imageSource).filter(Boolean)[0] || null,
          packshotImage: imageSource(slideList[Number(packshotIndex)])
        };
        if (siblingSlidesCache.size >= SIBLING_SLIDES_CACHE_MAX) {
          siblingSlidesCache.delete(siblingSlidesCache.keys().next().value);
        }
        siblingSlidesCache.set(handle, data);
        return data;
      })
      .catch(function () {
        return null;
      })
      .then(function (data) {
        siblingSlidesRequests.delete(handle);
        return data;
      });

    siblingSlidesRequests.set(handle, request);
    return request;
  }

  function applySiblingSlides(slider, handle, data) {
    var container = slider.closest('[data-plp-swipe]');
    var wrapper = slider.querySelector('.swiper-wrapper');
    if (!container || !wrapper) return;

    // Card context the product-route section render doesn't have.
    var currentImage = wrapper.querySelector('img[sizes]');
    var sizes = currentImage && currentImage.getAttribute('sizes');
    var currentLink = wrapper.querySelector('[data-collection-link]');
    var collectionLink = currentLink && currentLink.getAttribute('data-collection-link');
    var collectionTitle = currentLink && currentLink.getAttribute('data-collection-title');
    var hadSwiper = !!(slider.swiper && !slider.swiper.destroyed);

    destroySwiperFor(container);
    wrapper.innerHTML = data.html;

    if (sizes) {
      Array.prototype.forEach.call(wrapper.querySelectorAll('img[sizes]'), function (image) {
        image.setAttribute('sizes', sizes);
      });
    }
    if (collectionLink !== null) {
      Array.prototype.forEach.call(wrapper.querySelectorAll('[data-collection-link]'), function (link) {
        link.setAttribute('data-collection-link', collectionLink);
        link.setAttribute('data-collection-title', collectionTitle || '');
      });
    }

    slider.dataset.slidesHandle = handle;
    delete slider.dataset.packshotSlideIndex;
    container.setAttribute('data-packshot-index', data.packshotIndex);

    var firstIndex = firstImageSlideIndex(slider);
    slider.dataset.siblingSlideIndex = firstIndex === Infinity ? 0 : firstIndex;
    var targetIndex = isPackshotMode() ? getPackshotIndex(slider) : Number(slider.dataset.siblingSlideIndex);

    // Already preloaded: lazy-loading would defer it a frame and flash white.
    var targetImage = findSlideImage(slider, targetIndex);
    if (targetImage) targetImage.setAttribute('loading', 'eager');

    presetSlide(slider, targetIndex);
    if (hadSwiper || container.dataset.offscreen !== '1') {
      createSwiperFor(container);
    }
    showSlide(slider, targetIndex);
  }

  function isCurrentSibling(slider, handle) {
    return slider.isConnected && slider.dataset.siblingHandle === handle;
  }

  function swapWhenReady(slider, handle, data) {
    var target = isPackshotMode() ? data.packshotImage || data.firstImage : data.firstImage;
    var currentImage = slider.querySelector('.swiper-wrapper img[sizes]');
    var sizes = currentImage && currentImage.getAttribute('sizes');

    preloadImage(target && target.src, target && target.srcset, sizes).then(function () {
      if (!isCurrentSibling(slider, handle) || hasSiblingSlides(slider)) return;
      applySiblingSlides(slider, handle, data);
    });
  }

  function loadSiblingSlides(slider, handle) {
    var cached = siblingSlidesCache.get(handle);
    if (cached) {
      swapWhenReady(slider, handle, cached);
      return true;
    }

    fetchSiblingSlides(handle).then(function (data) {
      if (!data || !isCurrentSibling(slider, handle)) return;
      swapWhenReady(slider, handle, data);
    });
    return false;
  }

  function updateSiblingImage(event) {
    if (!event.detail || !event.detail.siblingImage || /^Liquid error/i.test(event.detail.siblingImage)) return;
    if (window.matchMedia && !window.matchMedia('(hover: none), (max-width: 749px)').matches) return;

    var slider = event.target.querySelector('[data-plp-swipe-slider]');
    if (!slider) return;
    if (!slider.swiper) initPlpSwipe();

    var handle = event.detail.siblingHandle || '';
    slider.dataset.siblingHandle = handle;
    slider.dataset.siblingImage = event.detail.siblingImage;
    slider.dataset.siblingTitle = event.detail.siblingTitle || '';
    delete slider.dataset.siblingPackshot;

    if (handle && hasSiblingSlides(slider)) {
      showSlide(slider, isPackshotMode() ? getPackshotIndex(slider) : Number(slider.dataset.siblingSlideIndex || 0));
      return;
    }
    if (handle && loadSiblingSlides(slider, handle)) return;

    // Interim first-image patch while the gallery loads (and fallback if that request fails).
    var siblingSlideIndex = firstImageSlideIndex(slider);
    if (siblingSlideIndex === Infinity) return;

    var siblingImage = event.detail.siblingImage;
    var siblingTitle = event.detail.siblingTitle;
    var slideImage = findSlideImage(slider, siblingSlideIndex);
    var sources = slideImage ? slideSources(slideImage, siblingImage) : {};

    preloadImage(sources.src, sources.srcset, slideImage && slideImage.getAttribute('sizes')).then(function () {
      if (!slider.isConnected || slider.dataset.siblingImage !== siblingImage || hasSiblingSlides(slider)) return;
      var packshotIndex = getPackshotIndex(slider);
      slider.dataset.siblingSlideIndex = siblingSlideIndex;
      slider.dataset.slidesHandle = '';
      updateSlideImage(slider, siblingSlideIndex, siblingImage, siblingTitle);
      showSlide(slider, isPackshotMode() ? packshotIndex : siblingSlideIndex);
    });
  }

  function updateSiblingPackshot(event) {
    if (!event.detail || !event.detail.siblingImage || /^Liquid error/i.test(event.detail.siblingImage)) return;
    var slider = event.target.querySelector('[data-plp-swipe-slider]');
    if (!slider || !slider.dataset.siblingImage) return;
    if (hasSiblingSlides(slider)) return;

    var packshotIndex = getPackshotIndex(slider);
    var packshotImage = event.detail.siblingImage;
    var siblingTitle = event.detail.siblingTitle;
    slider.dataset.siblingPackshot = packshotImage;
    if (packshotIndex !== Number(slider.dataset.siblingSlideIndex) || isPackshotMode()) {
      var slideImage = findSlideImage(slider, packshotIndex);
      var sources = slideImage ? slideSources(slideImage, packshotImage) : {};
      preloadImage(sources.src, sources.srcset, slideImage && slideImage.getAttribute('sizes')).then(function () {
        if (!slider.isConnected || slider.dataset.siblingPackshot !== packshotImage || hasSiblingSlides(slider)) return;
        updateSlideImage(slider, packshotIndex, packshotImage, siblingTitle);
        if (isPackshotMode()) showSlide(slider, packshotIndex);
      });
      return;
    }
    if (isPackshotMode()) showSlide(slider, packshotIndex);
  }

  /* ---------- packshot toggle ---------- */

  function applyPackshotState(container, isPackshot) {
    var slider = container.querySelector('[data-plp-swipe-slider]');
    if (!slider) return;

    var packshotIdx = getPackshotIndex(slider);
    var siblingIdx = Number(slider.dataset.siblingSlideIndex || 0);
    var targetIdx = isPackshot ? packshotIdx : siblingIdx;
    var source = isPackshot ? slider.dataset.siblingPackshot : slider.dataset.siblingImage;
    if (source && !hasSiblingSlides(slider)) updateSlideImage(slider, targetIdx, source, slider.dataset.siblingTitle);
    showSlide(slider, targetIdx);
  }

  function handlePackshotToggle(isPackshot) {
    if (window.matchMedia && !window.matchMedia('(hover: none), (max-width: 749px)').matches) return;
    initPlpSwipe();
    var swipers = document.querySelectorAll('[data-plp-swipe]');
    Array.prototype.forEach.call(swipers, function (container) {
      applyPackshotState(container, isPackshot);
      // SP-1685: never promote the whole grid at once (iOS memory, SP-1649).
      var slider = container.querySelector('[data-plp-swipe-slider]');
      if (container.dataset.offscreen === '0') {
        ensureSlideImages(container);
      } else if (slider && slider.swiper && !slider.swiper.destroyed) {
        promoteTargetSlide(slider, slider.swiper.activeIndex);
      }
    });
  }

  function bindPackshotToggle() {
    var toggle = document.getElementById('inverse-packshots');
    if (!toggle) return;

    toggle.addEventListener('change', function () {
      handlePackshotToggle(this.checked);
    });

    if (localStorage.getItem('plp-packshot') === 'true') {
      setTimeout(function() { handlePackshotToggle(isPackshotMode()); }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initPlpSwipe();
      bindPackshotToggle();
    });
  } else {
    initPlpSwipe();
    bindPackshotToggle();
  }

  document.addEventListener('theme:tab:init', initPlpSwipe);
  document.addEventListener('ajaxinate:loaded', initPlpSwipe);
  document.addEventListener('theme:sibling:change', updateSiblingImage);
  document.addEventListener('theme:sibling:packshot', updateSiblingPackshot);

  // SP-1685: swapped-in links miss theme.dev.js's per-element breadcrumb listener.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-slides-handle] .js-product-link');
    if (!link || !link.dataset.collectionLink) return;
    try {
      localStorage.setItem('collection-link', link.dataset.collectionLink);
      localStorage.setItem('collection-title', link.dataset.collectionTitle || '');
    } catch (e) {}
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      pauseAll(document);
    } else {
      resumeVisibleVideos();
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      resumeVisibleVideos();
    } else {
      initPlpSwipe();
    }
  });

  // Filters/sort replace `[data-products-grid]`'s innerHTML wholesale (theme.js), which recreates
  // the `.product-grid` element itself rather than just its children. Watching `.product-grid`
  // directly would mean the observer silently goes dead after the first filter change - it'd be
  // watching a detached node and never see anything happen to its replacement. `[data-products-grid]`
  // is the element whose content actually gets swapped, so it's the one that stays valid indefinitely.
  var gridWatchRoot = document.querySelector('[data-products-grid]') || document.querySelector('.product-grid');
  if (gridWatchRoot) {
    new MutationObserver(function (mutations) {
      var hasNew = false;
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.removedNodes, cleanupRemovedNode);
        if (!hasNew) {
          hasNew = Array.prototype.some.call(m.addedNodes, function (n) {
            return (
              n.nodeType === 1 &&
              (n.hasAttribute('data-plp-swipe') || n.querySelector('[data-plp-swipe]'))
            );
          });
        }
      });
      if (hasNew) {
        initPlpSwipe();
        if (isPackshotMode()) handlePackshotToggle(true);
      }
    }).observe(gridWatchRoot, { childList: true, subtree: true });
  }
})();
